/* NUFYT free-gift guard: Pack-of-6 box (3 packs) and 500g boxes (2 or 4 pouches) */
(function(){
  var busy=false,hasGift=false,t=null;
  function log(){try{console.log.apply(console,['[NUFYT gift]'].concat([].slice.call(arguments)))}catch(e){}}
  function drawerOpen(){
    var f=document.getElementById('flexy-cart-container');
    return !!(f&&f.classList.contains('visible'));
  }
  function handle(c){
    var packs=0,packGifts=[],groups={};
    (c.items||[]).forEach(function(it){
      var p=it.properties||{};
      if(p._nufyt_bundle_type==='500g'){
        /* 500g boxes: each box is checked on its own */
        var id=p._nufyt_bundle_id||'none';
        var g=groups[id]||(groups[id]={tier:Number(p._nufyt_bundle_tier)||0,pouches:0,gifts:[]});
        if(p._nufyt_gift)g.gifts.push(it);else g.pouches+=it.quantity;
        return;
      }
      /* Pack-of-6 box: unchanged rule (3 packs) */
      if(p._nufyt_gift)packGifts.push(it);
      else if(p._nufyt_bundle_id&&Number(p._nufyt_bundle_tier)===3)packs+=it.quantity;
    });
    var remove=[];
    if(packGifts.length){log('gift in cart, bundle packs =',packs);if(packs<3)remove=remove.concat(packGifts)}
    Object.keys(groups).forEach(function(id){
      var g=groups[id];
      if(!g.gifts.length)return;
      log('500g gift in cart, pouches =',g.pouches,'of',g.tier);
      if(g.pouches<g.tier)remove=remove.concat(g.gifts);
    });
    hasGift=packGifts.length>0||Object.keys(groups).some(function(id){return groups[id].gifts.length>0});
    if(remove.length){
      var u={};remove.forEach(function(g){u[g.key]=0});
      log('removing gift');
      return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates:u})})
        .then(function(){
          hasGift=false;
          try{if(window.FlexyPeCart&&typeof FlexyPeCart.open==='function')FlexyPeCart.open()}catch(e){}
        });
    }
  }
  function run(c){
    if(busy)return;busy=true;
    var job=c?Promise.resolve(handle(c)):fetch('/cart.js?t='+Date.now(),{headers:{Accept:'application/json'},cache:'no-store'}).then(function(r){return r.json()}).then(handle);
    job.catch(function(e){log('error',e)}).then(function(){busy=false});
  }
  var ox=XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open=function(m,u){
    var x=this;
    try{
      if(/\/cart\/(change|update)/.test(String(u))){
        x.addEventListener('load',function(){
          try{var c=JSON.parse(x.responseText);if(c&&c.items)run(c)}catch(e){}
        });
      }
    }catch(e){}
    return ox.apply(this,arguments);
  };
  document.addEventListener('click',function(){clearTimeout(t);t=setTimeout(function(){run()},400)},true);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)run()});
  run();
  setInterval(function(){if(!document.hidden&&(hasGift||drawerOpen()))run()},1500);
  window.nufytGiftCheck=function(){run()};
})();
